import {IndividualTransactionVolume, IndividualTransactionVolumeMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableIndividualTransactionVolumeProps {
	transactionVolume?: IndividualTransactionVolume
	setTransactionVolume: (value: IndividualTransactionVolume) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: IndividualTransactionVolume) => void
	className?: string
}

export function EditableIndividualTransactionVolumeField(props: EditableIndividualTransactionVolumeProps) {
	if (props.transactionVolume) {
		return (
			<Editable
				label="Transaction Volume"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setTransactionVolume}
				value={props.transactionVolume}
				initial={props.transactionVolume}
				update={props.update}
				className={props.className}
				possibleValues={IndividualTransactionVolumeMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
